@use "@styles/_variables/colors" as *;
@use "@styles/_variables/breakpoints" as *;
@use "@styles/_variables/sizes" as *;
@use "@styles/_variables/mixins" as *;
@use "@styles/_variables/typography" as *;

.home {
}

// In-copy tab switch: a button so the SPA can change tabs, dressed exactly
// like the surrounding prose links (Information.module.scss p a).
.link-button {
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  letter-spacing: inherit;
  color: $url;
  cursor: pointer;

  &:hover,
  &:active {
    color: $url-hoover;
    text-shadow: $text-glow-strong;
  }
}

// Section-closing CTA in the mobile menu's HUD-frame language: the shared
// technoCard chamfer/ring/ticks/orbit kit on a real button, with the
// menu's active-item gold label.
.contact-button {
  @include technoCard();
  display: block;
  // The closing bar must sit below the section's floated art, never beside it.
  clear: both;
  width: 70%;
  min-height: 5rem;
  margin: $tab-double auto 0;
  padding: 0 2rem;
  border: none;
  cursor: pointer;
  text-align: center;
  line-height: 5rem;
  font-family: $font-display-bold;
  font-size: $header-menu-font;
  text-transform: uppercase;
  color: $gold-light;
  text-shadow: $text-glow;
  // technoCard's var/tick tweens, extended with the label's own warm-up
  // (redeclaring transition replaces the mixin's list, so restate it).
  transition:
    --tc-cut-tl 0.35s ease,
    --tc-cut-tr 0.35s ease,
    --tc-cut-br 0.35s ease,
    --tc-cut-bl 0.35s ease,
    --tc-line 0.35s ease,
    background-size 0.35s ease,
    color 0.35s ease,
    text-shadow 0.35s ease;

  &:hover,
  &:active {
    color: #fff;
    text-shadow: $text-glow-strong;
  }

  &:focus {
    outline: none;
  }
}
